/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_PropertyInputs */

const cs_field_property = /** @type {(inputs: Field_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost`)
};

const en_field_property = /** @type {(inputs: Field_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property`)
};

/**
* | output |
* | --- |
* | "Property" |
*
* @param {Field_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_property = /** @type {((inputs?: Field_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_property(inputs)
	return cs_field_property(inputs)
});